<template>
  <div>
    <video autoplay controls id="video" style="width:100%"></video>
    <audio autoplay controls id="audio" style="width:100%"></audio>
  </div>
</template>
<script>
export default {
  props: ["remoteAudioStream", "remoteVideoStream"],
  data() {
    return {
      video: null,
      audio: null,
      audioPlayPromise: null,
    };
  },

  mounted() {
    this.video = document.querySelector("#video");
    if (this.video) {
      this.video.id = "v" + new Date().getTime();
    }
    this.audio = document.querySelector("#audio");
    if (this.audio) {
      this.audio.id = "a" + new Date().getTime();
    }
    console.log("PeerVideo: video="+this.video+" audio="+this.audio);
  },

  methods: {
    play(stream, element, volume) {
      console.log("PeerVideo:play() stream="+stream+" element="+element+" volume="+volume);
      if ("srcObject" in element) {
        element.srcObject = stream;
      } else {
        element.src = window.URL.createObjectURL(stream);
      }
      this.audioPlayPromise = element.play();
      element.volume = volume;
    },
    pause(element) {
      if (this.audioPlayPromise) {
        this.audioPlayPromise.then(()=>{
          element.pause();
        })
      }
      if ("srcObject" in element) {
        element.srcObject = null;
      } else {
        if (element.src && element.src !== "") {
          window.URL.revokeObjectURL(element.src);
        }
        element.src = "";
      }
    }
  },
  watch: {
    remoteVideoStream(s) {
      console.log("PeerVideo:remoteVideoStream() s="+s);
      if (s) {
        this.play(s, this.video, 0);
      } else {
        this.pause(this.video);
      }
    },
    remoteAudioStream(s) {
      console.log("PeerVideo:remoteAudioStream() s="+s);
      if (s) {
        this.play(s, this.audio, 1);
      } else {
        this.pause(this.audio);
      }
    }
  }
};
</script>
